<template>
  <div class="estrutura">
    <loader object="#df3e46" v-show="progress > 0" color1="#0db9d3" color2="#fff01f" size="6" speed="2.4" bg="#C0C0C0"
      objectbg="#0d0c0d" opacity="50" name="circular"></loader>

    <div class="container-fluid">
      <ol class="breadcrumb-arrow">
        <li>
          <a href="/home"><i class="fa fa-home"></i></a>
          <a href="#">Estrutura</a>
        </li>
      </ol>
    </div>

    <div class="container-fluid mt-2">
      <ul class="nav nav-tabs" id="myTab" role="tablist">
        <li class="nav-item">
          <a class="nav-link active" id="gt-tab" data-toggle="tab" href="#gt" role="tab" aria-controls="gt"
            aria-selected="true">
            Grupos de Trabalho
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" id="coord-tab" data-toggle="tab" href="#coord" role="tab" aria-controls="coord"
            aria-selected="false">
            Coordenação
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" id="dpto-tab" data-toggle="tab" href="#dpto" role="tab" aria-controls="dpto"
            aria-selected="false">
            Departamento
          </a>
        </li>
      </ul>
      <div class="tab-content" id="myTabContent">
        <!-- Grupos de Trabalho -->
        <div class="container-fluid mt-2 tab-pane fade show active" id="gt" role="tabpanel" aria-labelledby="gt-tab">
          <div class="card">
            <div class="card-body">
              <div class="row p-2">
                <div class="col-1 text-right mt-1">Filtro:</div>
                <div class="col">
                  <input placeholder="Filtrar Grupo de Trabalho" v-model="filtroGT" @keyup="filtrarGT" />
                </div>
                <div class="col text-right">
                  <button type="button" class="btn btn-primary" @click="abrirModalAdd('gt')">
                    <i class="fas fa-plus-circle mr-2"></i>
                    Grupo de Trabalho
                  </button>
                </div>
              </div>

              <table class="table table-hover">
                <thead>
                  <tr>
                    <th width="20%">Nome</th>
                    <th width="40%">Descrição</th>
                    <th width="20%">Coordenação</th>
                    <th width="10%" class="text-center">Ativo</th>
                    <th width="10%"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="gt in gts" :key="gt.id">
                    <td>
                      {{ gt.nome.substring(0, 35).trim() }}<span v-if="gt.nome.length > 35">...</span>
                    </td>
                    <td>
                      {{ gt.descricao.substring(0, 30).trim() }}<span v-if="gt.descricao.length > 30">...</span>
                    </td>
                    <td>{{ (gt.coordenacao) ? gt.coordenacao.nome.substring(0, 30).trim() : "-" }}<span
                        v-if="gt.coordenacao && gt.coordenacao.nome.length > 30">...</span> </td>
                    <td class="text-center">
                      <i v-show="gt.isAtivo" class="fas fa-check-circle text-success"></i>
                      <i v-show="!gt.isAtivo" class="fas fa-minus"></i>
                    </td>
                    <td class="text-center">
                      <el-tooltip :content="`Alterar ` + gt.nome" placement="top">
                        <i class="fas fa-edit pr-2 pl-2 text-warning clickable"
                          @click="abrirModalAlterar('gt', gt)"></i>
                      </el-tooltip>
                      <el-tooltip :content="`Desativar ` + gt.nome" placement="top">
                        <i class="far fa-trash-alt pr-2 pl-2 text-danger clickable" @click="excluirGT(gt)"></i>
                      </el-tooltip>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- Fim: Grupos de Trabalho -->

        <!-- Coordenação -->
        <div class="container-fluid mt-2 tab-pane fade show" id="coord" role="tabpanel" aria-labelledby="coord-tab">
          <div class="card">
            <div class="card-body">
              <div class="row p-2">
                <div class="col-1 text-right mt-1">Filtro:</div>
                <div class="col">
                  <input placeholder="Filtrar Coordenação" v-model="filtroCoord" @keyup="filtrarCoord" />
                </div>
                <div class="col text-right">
                  <button type="button" class="btn btn-primary" @click="abrirModalAdd('coord')">
                    <i class="fas fa-plus-circle mr-2"></i>
                    Coordenação
                  </button>
                </div>
              </div>

              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>Nome</th>
                    <th class="text-center">Sigla</th>
                    <th>Coordenador(es)</th>
                    <th>Departamento</th>
                    <th class="text-center">Ativo</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="coord in coords" :key="coord.id">
                    <td>
                      {{ coord.nome.substring(0, 35).trim() }}<span v-if="coord.nome.length > 35">...</span>
                    </td>
                    <td class="text-center">{{ coord.sigla }}</td>
                    <td>
                      <div v-for="usuario in coord.listaCoordenador" :key="usuario.idusuario">
                        - {{ usuario.nome }}
                      </div>
                    </td>
                    <td>
                      {{ coord.departamento.nome.substring(0, 30).trim() }}<span
                        v-if="coord.departamento.nome.length > 30">...</span>
                    </td>
                    <td class="text-center">
                      <i v-show="coord.isAtivo" class="fas fa-check-circle text-success"></i>
                      <i v-show="!coord.isAtivo" class="fas fa-minus"></i>
                    </td>
                    <td class="text-center">
                      <el-tooltip :content="`Alterar ` + coord.nome" placement="top">
                        <i class="fas fa-edit pr-2 pl-2 text-warning clickable"
                          @click="abrirModalAlterar('coord', coord)"></i>
                      </el-tooltip>
                      <el-tooltip content="Associar Coordenadores" placement="top">
                        <i class="fas fa-users pr-2 pl-2 text-secondary clickable"
                          @click="abrirModalCoordenador(coord)"></i>
                      </el-tooltip>
                      <el-tooltip :content="`Desativar ` + coord.nome" placement="top">
                        <i class="far fa-trash-alt pr-2 pl-2 text-danger clickable" @click="excluirCoord(coord)"></i>
                      </el-tooltip>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- Fim: Coordenação -->

        <!-- Departamento -->
        <div class="container-fluid mt-2 tab-pane fade show" id="dpto" role="tabpanel" aria-labelledby="dpto-tab">
          <div class="card">
            <div class="card-body">
              <div class="row p-2">
                <div class="col-1 text-right mt-1">Filtro:</div>
                <div class="col">
                  <input placeholder="Filtrar Departamento" v-model="filtroDpto" @keyup="filtrarDpto" />
                </div>
                <div class="col text-right">
                  <button type="button" class="btn btn-primary" @click="abrirModalAdd('dpto')">
                    <i class="fas fa-plus-circle mr-2"></i>
                    Departamento
                  </button>
                </div>
              </div>

              <table class="table table-hover">
                <thead>
                  <tr>
                    <th width="30%">Nome</th>
                    <th>Sigla</th>
                    <th>Diretor(es)</th>
                    <th>Descrição</th>
                    <th width="15%" class="text-center">Ativo</th>
                    <th width="10%"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="dpto in dptos" :key="dpto.id">
                    <td>
                      {{ dpto.nome.substring(0, 50).trim() }}<span v-if="dpto.nome.length > 50">...</span>
                    </td>
                    <td>{{ dpto.sigla }}</td>
                    <td>
                      <div v-for="usuario in dpto.listaDiretor" :key="usuario.idusuario">
                        - {{ usuario.nome }}
                      </div>
                    </td>
                    <td>
                      {{ dpto.descricao.substring(0, 35).trim() }}<span v-if="dpto.descricao.length > 35">...</span>
                    </td>
                    <td class="text-center">
                      <i v-show="dpto.isAtivo" class="fas fa-check-circle text-success"></i>
                      <i v-show="!dpto.isAtivo" class="fas fa-minus"></i>
                    </td>
                    <td class="text-center">
                      <el-tooltip :content="`Alterar ` + dpto.nome" placement="top">
                        <i class="fas fa-edit pr-2 pl-2 text-warning clickable"
                          @click="abrirModalAlterar('dpto', dpto)"></i>
                      </el-tooltip>
                      <el-tooltip content="Associar Diretores" placement="top">
                        <i class="fas fa-users pr-2 pl-2 text-secondary clickable"
                          @click="abrirModalDiretor(dpto)"></i>
                      </el-tooltip>
                      <el-tooltip :content="`Desativar ` + dpto.nome" placement="top">
                        <i class="far fa-trash-alt pr-2 pl-2 text-danger clickable" @click="excluirDpto(dpto)"></i>
                      </el-tooltip>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- Fim: Departamento -->
      </div>
    </div>

    <modal :show.sync="modals.modalGT">
      <form class="ml-3 mt-3 mr-3 mb-3">
        <h4 class="text-center">{{ opcao.label }} Grupo de Trabalho</h4>
        <div class="input-group">
          <div class="input-group-prepend mb-2">
            <span class="input-group-text"><i class="fas fa-align-left"></i></span>
          </div>
          <input type="text" maxlength="50" class="form-control mb-2" v-model="novaEstrutura.nome" placeholder="Nome" />
        </div>
        <div class="input-group">
          <div class="input-group-prepend mb-2">
            <span class="input-group-text"><i class="fas fa-align-left"></i></span>
          </div>
          <input type="text" maxlength="100" class="form-control mb-2" v-model="novaEstrutura.descricao"
            placeholder="Descrição" />
        </div>
        <div class="input-group">
          <div class="input-group-prepend mb-2" style="height: 40px">
            <span class="input-group-text"><i class="fas fa-user-circle"></i></span>
          </div>
          <select class="form-control" v-model="novaEstrutura.coordenacao" size="1" style="height: 40px">
            <option value="null">Selecione a coordenação</option>
            <option v-for="coord in listaCoords" :key="coord.id" :value="coord">
              {{ coord.nome }}
            </option>
          </select>
        </div>
        <div class="input-group">
          <div class="input-group-prepend mb-2">
            <span class="input-group-text"><i class="fas fa-align-left"></i></span>
          </div>
          <textarea rows="2" v-model="novaEstrutura.observacao" class="form-control mb-2"
            placeholder="Cadastre uma nova observação"></textarea>
        </div>



        <div class="input-group" style="width: 100%;">
          <div class="input-group-prepend mb-2">
            <span class="input-group-text"> <i class="fas fa-money-bill-alt mr-1"></i></span>
          </div>
          <vue-numeric label="Saldo disponível" tabindex="7" name="saldodisponivel" id="saldodisponivel"
            placeholder="Saldo disponível" class="form-control mb-2" v-model="novaEstrutura.saldodisponivel"
            separator="." v-bind:precision="2" v-bind:minus="false">
          </vue-numeric>
        </div>
        <div class="input-group">
          <div class="input-group-prepend mb-2">
            <span class="input-group-text"><i class="fas fa-toggle-off"></i></span>
          </div>
          <div class="col-2 custom-switch ml-2 mt-1 campoForm">
            <input type="checkbox" v-model="novaEstrutura.isAtivo" class="custom-control-input" id="check3" />
            <label class="custom-control-label" for="check3">Ativo</label>
          </div>
        </div>

        <br class="clear" />
        <div class="col-md-12 text-center mt-3">
          <button type="button" class="btn btn-primary" @click="alterarEstrutura('gt')">
            {{ opcao.name }}
          </button>
          <button type="button" class="btn btn-danger ml-4" @click="fecharModal">
            Desistir
          </button>
        </div>
      </form>
    </modal>

    <modal :show.sync="modals.modalCoord">
      <form class="ml-3 mt-3 mr-3 mb-3">
        <h4 class="text-center">{{ opcao.label }} Coordenação</h4>
        <div class="input-group">
          <div class="input-group-prepend mb-2">
            <span class="input-group-text"><i class="fas fa-align-left"></i></span>
          </div>
          <input type="text" maxlength="50" class="form-control mb-2" v-model="novaEstrutura.nome" placeholder="Nome" />
        </div>
        <div class="input-group">
          <div class="input-group-prepend mb-2">
            <span class="input-group-text"><i class="fa fa-font"></i></span>
          </div>
          <input type="text" class="form-control mb-2" v-model="novaEstrutura.sigla" placeholder="Sigla" />
        </div>
        <div class="input-group">
          <div class="input-group-prepend mb-2">
            <span class="input-group-text"><i class="fas fa-align-left"></i></span>
          </div>
          <input type="text" maxlength="100" class="form-control mb-2" v-model="novaEstrutura.descricao"
            placeholder="Descrição" />
        </div>
        <div class="input-group">
          <div class="input-group-prepend mb-2" style="height: 40px">
            <span class="input-group-text"><i class="fas fa-user-circle"></i></span>
          </div>
          <select class="form-control" v-model="novaEstrutura.departamento" size="1" style="height: 40px">
            <option value="null">Selecione o departamento</option>
            <option v-for="dpto in listaDptos" :key="dpto.id" :value="dpto">
              {{ dpto.nome }}
            </option>
          </select>
        </div>
        <div class="input-group">
          <div class="input-group-prepend mb-2">
            <span class="input-group-text"><i class="fas fa-align-left"></i></span>
          </div>
          <textarea rows="2" v-model="novaEstrutura.observacao" class="form-control mb-2"
            placeholder="Cadastre uma nova observação"></textarea>
        </div>
        <div class="input-group">
          <div class="input-group-prepend mb-2">
            <span class="input-group-text"><i class="fas fa-toggle-off"></i></span>
          </div>
          <div class="col-2 custom-switch ml-2 mt-1 campoForm">
            <input type="checkbox" v-model="novaEstrutura.isAtivo" class="custom-control-input" id="check2" />
            <label class="custom-control-label" for="check2">Ativo</label>
          </div>
        </div>

        <br class="clear" />
        <div class="col-md-12 text-center mt-3">
          <button type="button" class="btn btn-primary" @click="alterarEstrutura('coord')">
            {{ opcao.name }}
          </button>
          <button type="button" class="btn btn-danger ml-4" @click="fecharModal">
            Desistir
          </button>
        </div>
      </form>
    </modal>

    <modal :show.sync="modals.modalCoordenador">
      <form class="ml-3 mt-3 mr-3 mb-3">
        <h4 class="text-center">Associar Coordenador(es)</h4>
        <div class="input-group mt-3 mb-2">
          <dt>Coordenação: </dt> &nbsp; <dd> {{ coordenacao.nome }} - {{ coordenacao.sigla }}</dd>
        </div>
        <div class="input-group">
          <div class="input-group-prepend mb-2">
            <span class="input-group-text"><i class="fas fa-users"></i></span>
          </div>
          <v-select class="campoMultiplo mb-2" placeholder="Coordenadores" multiple label="nome"
            :reduce="(u) => u.idusuario" v-model="coordenacao.usuarios" :options="listaCoordenador">
            <span slot="no-options" @click="$refs.select.open = false">
              Nenhum registro encontrado
            </span>
          </v-select>
        </div>
        <br class="clear" />
        <div class="col-md-12 text-center mt-3">
          <button type="button" class="btn btn-danger" @click="fecharModal">
            Desistir
          </button>
          <button type="button" class="btn btn-primary ml-4" @click="associarCoordenador()">
            Associar
          </button>
        </div>
      </form>
    </modal>

    <modal :show.sync="modals.modalDiretor">
      <form class="ml-3 mt-3 mr-3 mb-3">
        <h4 class="text-center">Associar Diretor(es)</h4>
        <div class="input-group mt-3 mb-2">
          <dt>Departamento: </dt> &nbsp; <dd>{{ departamento.nome }} - {{ departamento.sigla }}</dd>
        </div>
        <div class="input-group">
          <div class="input-group-prepend mb-2">
            <span class="input-group-text"><i class="fas fa-users"></i></span>
          </div>
          <v-select class="campoMultiplo mb-2" placeholder="Diretores" multiple label="nome"
            :reduce="(u) => u.idusuario" v-model="departamento.usuarios" :options="listaDiretor">
            <span slot="no-options">Nenhum registro encontrado</span>
          </v-select>
        </div>
        <div class="col-md-12 text-center mt-3">
          <button type="button" class="btn btn-danger" @click="fecharModal">Desistir</button>
          <button type="button" class="btn btn-primary ml-4" @click="associarDiretor">Associar</button>
        </div>
      </form>
    </modal>

    <modal :show.sync="modals.modalDpto">
      <form class="ml-3 mt-3 mr-3 mb-3">
        <h4 class="text-center">{{ opcao.label }} Departamento</h4>
        <div class="input-group">
          <div class="input-group-prepend mb-2">
            <span class="input-group-text"><i class="fas fa-align-left"></i></span>
          </div>
          <input type="text" maxlength="50" class="form-control mb-2" v-model="novaEstrutura.nome" placeholder="Nome" />
        </div>
        <div class="input-group">
          <div class="input-group-prepend mb-2">
            <span class="input-group-text"><i class="fa fa-font"></i></span>
          </div>
          <input type="text" class="form-control mb-2" v-model="novaEstrutura.sigla" placeholder="Sigla" />
        </div>
        <div class="input-group">
          <div class="input-group-prepend mb-2">
            <span class="input-group-text"><i class="fas fa-align-left"></i></span>
          </div>
          <input type="text" maxlength="100" class="form-control mb-2" v-model="novaEstrutura.descricao"
            placeholder="Descrição" />
        </div>
        <div class="input-group">
          <div class="input-group-prepend mb-2">
            <span class="input-group-text"><i class="fas fa-align-left"></i></span>
          </div>
          <textarea rows="2" v-model="novaEstrutura.observacao" class="form-control mb-2"
            placeholder="Cadastre uma nova observação"></textarea>
        </div>
        <div class="input-group">
          <div class="input-group-prepend mb-2">
            <span class="input-group-text"><i class="fas fa-toggle-off"></i></span>
          </div>
          <div class="col-2 custom-switch ml-2 mt-1 campoForm">
            <input type="checkbox" v-model="novaEstrutura.isAtivo" class="custom-control-input" id="check1" />
            <label class="custom-control-label" for="check1">Ativo</label>
          </div>
        </div>

        <br class="clear" />
        <div class="col-md-12 text-center mt-3">
          <button type="button" class="btn btn-primary" @click="alterarEstrutura('dpto')">
            {{ opcao.name }}
          </button>
          <button type="button" class="btn btn-danger ml-4" @click="fecharModal">
            Desistir
          </button>
        </div>
      </form>
    </modal>
  </div>
</template>

<script>
import FileSaver from "file-saver";
import "vue-select/dist/vue-select.css";

export default {
  components: {},
  created() {
    this.carregarListaGT();
    this.carregarListaDpto();
    this.carregarListaCoord();
  },
  data() {
    return {
      gts: [],
      gtsFiltro: [],
      coords: [],
      coordsFiltro: [],
      dptos: [],
      dptosFiltro: [],
      filtroGT: "",
      filtroCoord: "",
      filtroDpto: "",
      listaCoords: [],
      listaDptos: [],
      novaEstrutura: {
        iddepartamento: null,
        idgt: null,
        idcoordenacao: null,
        departamento: null,
        coordenacao: null,
        nome: "",
        descricao: "",
        observacao: "",
        sAtivo: true,
        saldodisponivel: "",
      },
      modals: {
        modalGT: false,
        modalCoord: false,
        modalDpto: false,
        modalCoordenador: false,
        modalDiretor: false,
      },
      opcao: {
        label: "Adicionar",
        name: "Incluir",
      },
      progress: 3,
      coordenacao: {},
      listaCoordenador: [],
      departamento: {},
      listaDiretor: [],
    };
  },
  methods: {
    filtrarGT() {
      if (this.filtroGT === "") {
        this.gts = this.gtsFiltro;
      } else {
        this.gts = this.gtsFiltro.filter((item) => {
          return (
            item.nome.toUpperCase().indexOf(this.filtroGT.toUpperCase()) >= 0 ||
            item.descricao.toUpperCase().indexOf(this.filtroGT.toUpperCase()) >=
            0
          );
        });
      }
    },
    filtrarCoord() {
      if (this.filtroCoord === "") {
        this.coords = this.coordsFiltro;
      } else {
        this.coords = this.coordsFiltro.filter((item) => {
          return (
            item.nome.toUpperCase().indexOf(this.filtroCoord.toUpperCase()) >=
            0 ||
            item.descricao
              .toUpperCase()
              .indexOf(this.filtroCoord.toUpperCase()) >= 0
          );
        });
      }
    },
    filtrarDpto() {
      if (this.filtroDpto === "") {
        this.dptos = this.dptosFiltro;
      } else {
        this.dptos = this.dptosFiltro.filter((item) => {
          return (
            item.nome.toUpperCase().indexOf(this.filtroDpto.toUpperCase()) >=
            0 ||
            item.descricao
              .toUpperCase()
              .indexOf(this.filtroDpto.toUpperCase()) >= 0
          );
        });
      }
    },
    carregarListaGT() {
      //this.progress = true;
      this.$clubApi.get("/estrutura/gt").then((response) => {
    
        this.gts = response.data.object;
        console.log(this.gts);
        this.gtsFiltro = response.data.object;
      })
        .catch((error) => {
          this.$toastr.error(error.response.data.msg);
        })
        .finally(() => {
          this.progress = this.progress - 1;
        });
    },
    carregarListaCoord() {
      //this.progress = true;
      this.$clubApi
        .get("/estrutura/coord")
        .then((response) => {
          this.coords = response.data.object;
          this.coordsFiltro = response.data.object;
        })
        .catch((error) => {
          this.$toastr.error(error.response.data.msg);
        })
        .finally(() => {
          this.progress = this.progress - 1;
        });
    },
    carregarListaDpto() {
      //this.progress = true;
      this.$clubApi
        .get("/estrutura/dpto")
        .then((response) => {
          this.dptos = response.data.object;
          this.dptosFiltro = response.data.object;
        })
        .catch((error) => {
          this.$toastr.error(error.response.data.msg);
        })
        .finally(() => {
          this.progress = this.progress - 1;
        });
    },
    abrirModalAdd(estrutura) {
      this.opcao.label = "Adicionar";
      this.opcao.name = "Incluir";
      if (estrutura === "gt") {
        this.$clubApi.get("/estrutura/coord/ativo").then((response) => {
          this.listaCoords = response.data.object;
          this.modals.modalGT = true;
        });
      }
      if (estrutura === "coord") {
        this.$clubApi.get("/estrutura/dpto/ativo").then((response) => {
          this.listaDptos = response.data.object;
          this.modals.modalCoord = true;
        });
      }
      this.modals.modalDpto = estrutura === "dpto";
      this.novaEstrutura = {
        iddepartamento: null,
        idgt: null,
        idcoordenacao: null,
        departamento: null,
        coordenacao: null,
        nome: "",
        descricao: "",
        observacao: "",
        saldodisponivel: "",
        isAtivo: true,
      };
    },
    abrirModalCoordenador(coordenacao) {
      this.progress = this.progress + 1;
      this.$clubApi.get("/estrutura/coord/coordenadores").then((response) => {
        this.coordenacao = coordenacao;
        this.listaCoordenador = response.data.object;
        //this.coordenacao.usuarios = coordenacao.listaCoordenador;
        this.modals.modalCoordenador = true;
      })
        .catch((error) => {
          this.$toastr.error(error.response.data.msg);
        })
        .finally(() => {
          this.progress = this.progress - 1;
        });
    },
    associarCoordenador() {
      if (this.validacaoFormAssociacao()) {
        this.modals.modalCoordenador = false;
        const options = { title: "Confirmação", okLabel: "Sim", cancelLabel: "Não" };
        this.$dialogs.confirm("Deseja fazer a associação de coordenadores?", options).then((res) => {
          if (res.ok) {
            this.progress = this.progress + 1;
            let obj = {
              coordenacao: this.coordenacao.idcoordenacao,
              usuarios: this.coordenacao.usuarios
            }
            this.$clubApi.post("/estrutura/coord/associacao", obj).then(() => {
              this.$toastr.success("Associação realizada com sucesso!");
              this.carregarListaCoord();
            })
              .catch((error) => {
                this.$toastr.error(error.response.data.msg);
              })
              .finally(() => {
                this.progress = this.progress - 1;
                this.modals.modalCoordenador = false;
              });
          }
        });
      } else {
        this.$toastr.error("Nenhum nome selecionado para a associação!");
      }
    },
    validacaoFormAssociacao() {
      return !(this.coordenacao.usuarios == undefined || this.coordenacao.usuarios.length == 0);
    },
    abrirModalDiretor(departamento) {
      this.progress++;
      this.$clubApi.get("/estrutura/dpto/diretores").then((response) => {
        this.departamento = departamento;
        this.$set(this.departamento, "usuarios",
          (departamento.listaDiretor || []).map((usuario) => usuario.idusuario));
        this.listaDiretor = response.data.object;
        this.modals.modalDiretor = true;
      })
        .catch((error) => this.$toastr.error(error.response.data.msg))
        .finally(() => this.progress--);
    },
    associarDiretor() {
      this.modals.modalDiretor = false;
      const options = { title: "Confirmação", okLabel: "Sim", cancelLabel: "Não" };
      this.$dialogs.confirm("Deseja fazer a associação de diretores?", options).then((res) => {
        if (res.ok) {
          this.progress++;
          const obj = {
            departamento: this.departamento.iddepartamento,
            usuarios: this.departamento.usuarios || []
          };
          this.$clubApi.post("/estrutura/dpto/associacao", obj).then(() => {
            this.$toastr.success("Associação realizada com sucesso!");
            this.carregarListaDpto();
          })
            .catch((error) => this.$toastr.error(error.response.data.msg))
            .finally(() => {
              this.progress--;
              this.modals.modalDiretor = false;
            });
        }
      });
    },
    abrirModalAlterar(e, estrutura) {
      this.opcao.label = "Alterar";
      this.opcao.name = "Alterar";
      if (e === "gt") {
        this.$clubApi.get("/estrutura/coord/ativo").then((response) => {
          this.listaCoords = response.data.object;
          this.modals.modalGT = true;
        });
      }
      if (e === "coord") {
        this.$clubApi.get("/estrutura/dpto/ativo").then((response) => {
          this.listaDptos = response.data.object;
          this.modals.modalCoord = true;
        });
      }
      // seta o objeto da estrutura selecionada
      this.novaEstrutura = estrutura;

      this.modals.modalGT = e === "gt";
      this.modals.modalCoord = e === "coord";
      this.modals.modalDpto = e === "dpto";
    },
    alterarEstrutura(estrutura) {
      if (this.validacaoFormEstrutura()) {
        this.modals.modalGT = false;
        this.modals.modalCoord = false;
        this.modals.modalDpto = false;
        const options = {
          title: "Alteração",
          okLabel: "Sim",
          cancelLabel: "Não",
        };
        this.$dialogs.confirm(
          "Deseja realmente " +
          this.opcao.name.toLowerCase() +
          ' "' +
          this.novaEstrutura.nome +
          '"?',
          options
        )
          .then((res) => {
            if (res.ok) {
              this.progress = this.progress + 1;

              delete this.novaEstrutura.listaGrupoTrabalho;

              this.$clubApi.post("/estrutura/" + estrutura, this.novaEstrutura).then(() => {
                this.$toastr.success("Estrutura salva com sucesso!");
                this.carregarListaGT();
                this.carregarListaCoord();
                this.carregarListaDpto();
              })
                .catch((error) => {
                  this.$toastr.error(error.response.data.msg);
                })
                .finally(() => {
                  this.progress = this.progress - 1;
                  this.modals.modalGT = false;
                });
            }
          });
      } else {
        this.$toastr.error("Campos com preenchimento obrigatório!");
      }
    },
    fecharModal() {
      this.novaEstrutura = {
        iddepartamento: null,
        idgt: null,
        idcoordenacao: null,
        departamento: null,
        coordenacao: null,
        nome: "",
        descricao: "",
        observacao: "",
        saldodisponivel: "",
        isAtivo: true,
      };
      this.modals.modalGT = false;
      this.modals.modalCoord = false;
      this.modals.modalDpto = false;
      this.modals.modalCoordenador = false;
      this.modals.modalDiretor = false;
    },
    excluirGT(gt) {
      const options = {
        title: "Confirmação",
        okLabel: "Desativar",
        cancelLabel: "Não",
      };
      this.$dialogs.confirm('Deseja realmente desativar "' + gt.nome + '"?', options).then((res) => {
        if (res.ok) {
          this.progress = this.progress + 1;
          this.$clubApi
            .delete("/estrutura/gt/" + gt.idgt).then(() => {
              this.$toastr.success("Grupo de trabalho desativado com sucesso!");
              this.carregarListaGT();
            })
            .catch((error) => {
              this.$toastr.error(error.response.data.msg);
            })
            .finally(() => {
              this.progress = this.progress - 1;
            });
        }
      });
    },
    excluirCoord(coord) {
      const options = {
        title: "Confirmação",
        okLabel: "Desativar",
        cancelLabel: "Não",
      };
      this.$dialogs.confirm('Deseja realmente desativar "' + coord.nome + '"?', options).then((res) => {
        if (res.ok) {
          this.progress = this.progress + 1;
          this.$clubApi.delete("/estrutura/coord/" + coord.idcoordenacao).then(() => {
            this.$toastr.success("Coordenação desativada com sucesso!");
            this.carregarListaCoord();
          })
            .catch((error) => {
              this.$toastr.error(error.response.data.msg);
            })
            .finally(() => {
              this.progress = this.progress - 1;
            });
        }
      });
    },
    excluirDpto(dpto) {
      const options = {
        title: "Confirmação",
        okLabel: "Desativar",
        cancelLabel: "Não",
      };
      this.$dialogs.confirm('Deseja realmente desativar "' + dpto.nome + '"?', options).then((res) => {
        if (res.ok) {
          this.progress = this.progress + 1;
          this.$clubApi.delete("/estrutura/dpto/" + dpto.iddepartamento).then(() => {
            this.$toastr.success("Departamento desativado com sucesso!");
            this.carregarListaDpto();
          })
            .catch((error) => {
              this.$toastr.error(error.response.data.msg);
            })
            .finally(() => {
              this.progress = this.progress - 1;
            });
        }
      });
    },
    validacaoFormEstrutura() {
      return !(
        this.novaEstrutura.nome == "" || this.novaEstrutura.descricao == ""
      );
    },
    exportReport() {
      this.progress = this.progress + 1;
      this.$clubApi.get("/estrutura/report", { responseType: "blob", }).then((response) => {
        var nomeArquivoHeaders = response.headers["content-disposition"];
        var nomeArquivo = nomeArquivoHeaders;
        var contentType = response.headers["content-type"];
        var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        var matches = filenameRegex.exec(nomeArquivoHeaders);
        nomeArquivo = matches[1].replace(/['"]/g, "");
        var blob = new Blob([response.data], {
          type: contentType,
        });
        FileSaver.saveAs(blob, nomeArquivo);
      })
        .catch((error) => {
          this.$toastr.error(error.response.data.msg);
        })
        .finally(() => {
          this.progress = this.progress - 1;
        });
    },
  },
};
</script>
<style scoped>
.container-fluid { padding-left: 10px !important; padding-right: 10px !important; }
.clickable {
  cursor: pointer;
}

.campoMultiplo {
  width: 90%;
}
</style>
